import { render, staticRenderFns } from "./AnalResultComponent.vue?vue&type=template&id=5b04f1df&scoped=true"
import script from "./AnalResultComponent.vue?vue&type=script&lang=js"
export * from "./AnalResultComponent.vue?vue&type=script&lang=js"
import style0 from "./AnalResultComponent.vue?vue&type=style&index=0&id=5b04f1df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04f1df",
  null
  
)

export default component.exports